<template>
  <v-dialog v-model="localDialog" scrollable max-width="600" lazy>
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>
          {{ $t('titles.global.updatedRecord') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('update:dialog', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <!-- <v-layout row wrap my-3 v-for="(item, index) of updated" :key="index + 322">
          <v-flex
            xs12
            md6
          >{{item.updatedBy ? item.updatedBy.name + ' ' + item.updatedBy.lastname1 : '-'}}</v-flex>
          <v-flex xs12 md6 class="text-xs-center">{{formatDate(item.updatedAt)}}</v-flex>
        </v-layout>-->
        <v-card flat>
          <v-toolbar card color="white">
            <v-text-field
              v-model="search"
              flat
              hide-details
              :placeholder="$t('action.buttons.search')"
              prepend-icon="search"
              solo
            />
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="formatedList"
              :rows-per-page-items="[
                5,
                10,
                20,
                { text: $t('action.buttons.all'), value: -1 },
              ]"
              :search="search"
              disable-initial-sort
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.updatedBy }}</td>
                <td v-if="props.item.type">
                  {{ props.item.type }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.updatedAt }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="$emit('update:dialog', false)" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'DialogUpdated',
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: false,
    },
    updated: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    localDialog: {
      get() {
        return this.dialog
      },
      set() {
        this.$emit('update:dialog', false)
      },
    },
    formatedList() {
      return this.updated
        .map((item) => {
          return {
            updatedBy: item.updatedBy
              ? item.updatedBy.name + ' ' + item.updatedBy.lastname1
              : '-',
            updatedAt: formatDate(item.updatedAt, true),
            type: item.type ? this.$t(`action.buttons.${item.type}`) : ' ',
          }
        })
        .reverse()
    },
    headers() {
      return [
        {
          text: this.$t('fields.global.updatedBy'),
          value: 'updatedBy',
        },
        {
          text: this.$t('fields.global.actions'),
          value: 'type',
        },
        {
          text: this.$t('fields.global.updatedAt'),
          align: 'center',
          value: 'updatedAt',
        },
      ]
    },
  },
}
</script>
